import Lottie from "lottie-react";
import loadingSpinner from "assets/loader-white.json";

export default function WhiteLoader() {
  return (
    <div style={{height: '100%', width: '100%'}}>
      <Lottie animationData={loadingSpinner} loop={true} />
    </div>
  );
}